<template lang="pug">
.row.justify-between.q-mt-sm
    .skeleton-items.col-12(
        v-for="i in count"
        :key="i")
        .row.skeleton.relative-position.justify-between.q-pb-md(:style="styleSkeleton")
            .absolute-top-right
                q-skeleton.q-mr-md(
                    width="24px"
                    height="24px"
                    :class="`bg-${background}`")
            .col-2.q-skeleton.q-mt-lg(
                height="107px"
                :class="`bg-${background}`")
            .col-6.column.q-mt-lg
                q-skeleton(
                    height="20px"
                    :class="`bg-${background}`")
                q-skeleton.q-mt-xs(
                    height="20px"
                    :class="`bg-${background}`")
                q-skeleton.q-mb-md.q-mt-xs(
                    height="20px"
                    :class="`bg-${background}`")
                q-skeleton(
                    height="30px"
                    width="200px"
                    :class="`bg-${background}`")
            .col-3.flex.justify-end.items-end
                q-skeleton.q-mt-md(
                    height="44px"
                    width="100%"
                    :class="`bg-${background}`")              
</template>

<script>
import { ref, computed } from 'vue';

export default {
    name: 'Drugstores-skeleton',
    props: {
        height: {
            type: Number,
            default: 150,
        },
        background: {
            type: String,
            default: 'grey-6',
        },
    },
    setup(props) {
        const count = ref(10);
        const styleSkeleton = computed(() => `height: ${props.height}px;`);

        return {
            count,
            styleSkeleton,
        };
    },
};
</script>

